import { Select } from '@onwardtravelsolutions/package-react/Components';
import { ValidationStatus } from '@onwardtravelsolutions/package-react/Enums';
import { useFieldFocus } from '@onwardtravelsolutions/package-react/Hooks';
import { Notice } from '@onwardtravelsolutions/package-react/Types';
import { getValidation } from '../../Utilities/validation';
import Field from './Field';
import FieldValidation from './FieldValidation';

type SelectFieldProps = {
    id: string;
    className?: string;
    label?: string;
    children?: React.ReactNode;
    status?: ValidationStatus;
    notices?: Notice[];
    isDirty?: boolean;
    setValue?: (value: any) => void;
    onChange?: React.ChangeEventHandler<HTMLSelectElement>;
} & React.SelectHTMLAttributes<HTMLSelectElement>;

export default function SelectField({
    id,
    label = null,
    status,
    notices = [],
    className = null,
    children,
    onChange = null,
    setValue = null,
    isDirty = false,
    ...rest
}: SelectFieldProps) {
    const { isFocused, focusHandlers } = useFieldFocus(false);
    const validation = getValidation(status);

    return (
        <Field id={id} label={label} className={className}>
            <FieldValidation
                id={id}
                status={status}
                notices={notices}
                showNotices={isFocused}
            >
                <Select
                    {...{
                        id: `field-${id}`,
                        className: `inset-shadow-sm bg-gray-50 dark:bg-neutral-700 border border:solid border-2 ${validation.borderClasses} rounded w-full dark:text-neutral-200`,
                        onChange:
                            onChange ??
                            ((event) => setValue?.(event.currentTarget.value)),
                        ...focusHandlers,
                        ...rest,
                    }}
                >
                    {children}
                </Select>
            </FieldValidation>
        </Field>
    );
}
